import UI from "./base/UI"; 

import {isA11yCheckVersion, a11yDebounceLeading, isA11ySlideFocusMove} from "../functions/a11y.ui";
import Popup from "./base/Popup";
import Tab from "./Tab";
/**
 * ToggleRadio
 */

 /**
#### HTML 구조 및 Data 속성 사용법
** [http://172.20.160.28:9700/kbank_html_mmk/components/component_tab.html](http://172.20.160.28:9700/kbank_html_mmk/components/component_tab.html)
*/
class ToggleRadio extends UI {

    prevIndex;
    activeIndex;

    constructor(el, options) {
        super('ToggleRadio', el);

        this.init(el, options);
    }

    init(el, options) {
        if (options) {
            this.defaults = {...this.defaults, ...this.parseOptions(options)};
        }

        this.render();
        this.mapping = el.dataset.mapping;
        this.activeIndex = this.getActiveIndex();
    }

    render() {
        this.detachEvents();
        this.attachEvents();
    }

    update() {
        const linkBtn = this.$el.find('.toggle-link');
        linkBtn.css({
            '-webkit-tap-highlight-color': 'transparent'
        });
        
        /* 기존소스
        this.$el.find('.move-item').css({
            'width': `${this.$el.find('.toggle-item.active')[0].getBoundingClientRect().width}px`,
            'opacity':1,
            'transition': 'opacity .3s ease-in-out',
            'transform': `translate(${this.$el.find('.toggle-item.active').position().left}px, 0)`,
        });

        this.$el.find('.move-item').css({
            'transition': 'all .3s ease-in-out',
        });
        */

        //초반 로드시 active이동모션 없이 active 표시
        this.moveItemFocusMove();

        /*기존소스*/
        //this.contMapping();
    }

    attachEvents() {
        this.update();
        this.$el.on('change customChange', ':radio', (e) => {
            const $this = $(e.currentTarget);
            const $toggleItem = $this.closest('.toggle-item');

            this.prevIndex = this.prevIndex ?? this.activeIndex;
            if ($this.attr('disabled') != undefined) {  // FETASK-1415 :  라디오 비활성화 (disabled) 경우 클릭x
                 return false
            }
            if($this.prop('checked') === true) {
                this.$el.find('.move-item').css({
                    'transform': `translate(${$toggleItem.position().left}px, 0)`,
                    'width': `${$this[0].getBoundingClientRect().width}px`
                });

                if (this.defaults.activeControl !== false) { //data-active-control="false" case 제외 
                    this.$el.find('.toggle-item').removeClass('active');
                    $toggleItem.addClass('active');
                    this.activeIndex = this.getActiveIndex();
                }
                // SR-1860 스피너 트리거
                if ($toggleItem.attr('data-mapping-spinner')) {
                    const mappingSpinner = $toggleItem.attr('data-mapping-spinner');
                    $(`[data-area='${mappingSpinner}'] input`).trigger('click')
                }
            }
            this.contMapping();
        })

        /*! s: FETASK-a11y page 토글라디오 접근성 속성 및 focus로직 v.1.0.0 */
        this.isA11yAccessHandle();
        /*! e: FETASK-a11y page 토글라디오 접근성 속성 및 focus로직 v.1.0.0 */
    }

    detachEvents() {
        this.$el.find('.toggle-item').off('click');
    }

    destroy() {
        this.detachEvents();
    }

    restore(){
        // console.log(Array.from(this.$el.find('.toggle-item')));
        if(this.activeIndex === this.prevIndex || this.prevIndex == undefined) return false;
        const toggleItems = Array.from(this.$el.find('.toggle-item'));
        const activeItem = toggleItems.filter(item => $(item).hasClass('active'));
        $(activeItem).removeClass('active');
        $(activeItem).find('input[type=radio]').prop('checked', false);

        const prevActiveItem = toggleItems[this.prevIndex];
        $(prevActiveItem).removeClass('active');
        $(prevActiveItem).find('input[type=radio]').prop('checked', true);
        this.activeIndex = this.prevIndex;
    }
   
    setActiveIndex(){
        this.activeIndex = this.getActiveIndex();
        this.prevIndex = this.activeIndex;
    }
     /**
     * 현재 선택된 active index 값을 가져오는 함수
     * @returns {Number} active index값
     * @example 
     * $('.ui-ToggleRadio').data('ui').getActiveIndex();
     */
    getActiveIndex(){
        return Array.from(this.$el.find('.toggle-item')).findIndex(item => $(item).hasClass('active'));
    }

    contMapping() {
        if (this.mapping == 'true') {
            const mappingControl = this.$el.find('.toggle-item[data-mapping-cont]');

            mappingControl.each((i, btn) => {
                const radio = $(btn).find('input');
                const mappingBox = $(btn).attr('data-mapping-cont');

                // if (radio.is(':checked')) {
                if ($(btn).hasClass('active')) {
                    $(`[data-mapping-toggle="${mappingBox}"]`).show();
                    // $(`[data-mapping-toggle="${mappingBox}"]`).stop().slideDown();
                } else {
                    $(`[data-mapping-toggle="${mappingBox}"]`).hide();
                    // $(`[data-mapping-toggle="${mappingBox}"]`).stop().slideUp();
                }
            });
        }
    }

    /*! s: FETASK-a11y page 처음 로드시 focus 애니매이션 없이 이동 v.1.0.0 */
    moveItemFocusMove(){
        $(document).ready(async () => {
            //해당 로직보다 뒤로 실행시키기위해 비동기로 실행
            const delay1 = new Promise((resolve) => setTimeout(resolve, 20));

            await delay1;
            
            if(!this.$el.find('.toggle-item.active')) return;
  
            await this.$el.find('.move-item').css({
                // 기존로직
                // 'width': `${this.$el.find('.toggle-item.active')[0]?.clientWidth}px`,
                // 'transform': `translate(${this.$el.find('.toggle-item.active').position().left}px), 0)`,
                
                // 240319 width / translate 로직 수정
                'width': `calc(100% / ${this.$el.find('.toggle-item')?.length})`,
                'opacity':1,
                'transition': 'initial',
                'transform': `translate(calc(100% * ${this.$el.find('.toggle-item.active').index()-1}), 0)`,
            });

            //해당 로직보다 뒤로 실행시키기위해 비동기로 실행
            const delay2 = new Promise((resolve) => setTimeout(resolve, 10));

            await delay2;

            await this.$el.find('.move-item')
                .css({
                    'transition': 'all .3s ease-in-out',
                })
                .promise()
                .done(() => {
                    this.contMapping();
                });
        })
    }
    /*! e: FETASK-a11y page 처음 로드시 focus 애니매이션 없이 이동 v.1.0.0 */

    /*! s: FETASK-a11y page 위젯 스크린리더 속성 및 focus로직 v.1.0.0 */
    isA11yAccessHandle(){
        requestAnimationFrame(() => {
            const isA11yCheck = isA11yCheckVersion(); //html a11y class존재시 실행

            if(isA11yCheck){
                //일반 RadioToggle버튼 로직
                this.isDefaultRadio();
                
                //Radio + contents 로직
                this.isA11yRadioMixContents();
            }
        });
    }
    /*! e: FETASK-a11y page 위젯 스크린리더 속성 및 focus로직 v.1.0.0 */

    /*! s: FETASK-a11y page 일반 RadioToggle 로직 v.1.0.0 */
    async isDefaultRadio(){
        const toggleActiveItem = this.$el[0].querySelector('.ui-ToggleRadio:not(.input-radio-btn-area) .toggle-item.active');
        const toggleItemEles = this.$el[0].querySelectorAll('.ui-ToggleRadio:not(.input-radio-btn-area) .toggle-item');
        const toggleInputEles = this.$el[0].querySelectorAll('.ui-ToggleRadio:not(.input-radio-btn-area) .toggle-item input');

        if(!toggleActiveItem) return;

        //다른 로직에서 tabindex 넣는 로직이 존재하여 해당 로직보다 뒤로 실행시키기위해 비동기로 실행
        const delay = new Promise((resolve) => setTimeout(resolve, 500));

        await delay;

        //toggleRadio 하위 input 스크린리더 focus막기
        await Array.from(toggleInputEles).forEach((list) => {
            list.setAttribute('aria-hidden','true');
            list.style.zIndex = '-1';
        });

        await Array.from(toggleItemEles).forEach((list,idx) => {
            const toggleDiv = list;
            const toggleItem = list.querySelector('a, label');
            const toggleSpan = list.querySelector('span');
            const toggleInputEle = list.querySelector('input');
            const isToggleInputDisabled = toggleInputEle.disabled;

            toggleDiv.parentElement.setAttribute('role','radiogroup');
            toggleDiv.setAttribute('role','radio');
            toggleDiv.setAttribute('aria-checked','false');
            // toggleDiv.setAttribute('title', `${toggleItem?.children[0]?.innerText}`);
            toggleDiv.setAttribute('aria-label', `${toggleItem?.children[0]?.innerText}`); //A11YTASK-469,477,483 : title속성 aria-label로 변경 (2025.04.09)

            toggleActiveItem?.setAttribute('aria-checked','true');

            toggleItem?.removeAttribute('tabindex');
            toggleItem?.setAttribute('aria-hidden','true');

            toggleSpan?.setAttribute('aria-hidden','true');

            toggleInputEle?.removeAttribute('tabindex');

            if(isToggleInputDisabled){
                //인풋 disabled 적용
                toggleDiv.removeAttribute('aria-checked');
                toggleDiv.setAttribute('aria-disabled','true');
                toggleDiv.setAttribute('disabled','true');
                // toggleDiv.setAttribute('title', '선택할수없음');
                toggleDiv.setAttribute('aria-label', '선택할수없음'); //A11YTASK-469,477,483 : title속성 aria-label로 변경 (2025.04.09)
                toggleDiv.style.pointerEvents = 'none';
            }

            toggleDiv.addEventListener('click',(e) => {

                if(isToggleInputDisabled) return;

                const curIndex = $(e.currentTarget).index();

                $(toggleItemEles).removeClass('active');
                $(toggleDiv).addClass('active');
                
                let count = 0;
                let interval = setInterval(() => {
                    if(count >= 10){
                        clearInterval(interval);
                    }
                    if($('.activePopup')?.length){
                        $('.activePopup').attr('aria-hidden','false');
                        $('body').removeAttr('style');
                        $('.component-picker-spinner').attr('style','display:none');
                        $('.component-picker-spinner').find('.ui-input.hide-txt').attr('aria-hidden','true');
                        $('.component-picker-spinner').eq(curIndex - 1).removeAttr('style');

                    }
                    
                    if(!$(toggleItemEles)?.focus()){
                        $(toggleItemEles).eq(idx).attr({'tabindex':'0', 'aria-hidden':'false'}).focus();
                    }

                    count++;
                },100);


                Popup.a11yDetctClosePopup();
                
                Array.from([...toggleItemEles, ...toggleInputEles]).forEach((list) => {

                    if(list.nodeName === 'DIV'){
                        list.setAttribute('aria-checked','false');
                    }
                });

                // toggleDiv.setAttribute('title', `${toggleItem?.children[0]?.innerText}`);
                toggleDiv.setAttribute('aria-label', `${toggleItem?.children[0]?.innerText}`); //A11YTASK-469,477,483 : title속성 aria-label로 변경 (2025.04.09)
                
                toggleDiv.setAttribute('aria-checked','true');

                toggleInputEle.setAttribute('title', '');

                //$(toggleInputEles).prop('checked', false);
                //$(toggleInputEle).prop('checked', true);
                $(toggleInputEle).trigger('click');
            });
        });
    }
    /*! e: FETASK-a11y page 일반 RadioToggle 로직 v.1.0.0 */

    /*! s: FETASK-a11y page 일반 isA11yRadioMixContents 로직 v.1.0.0 */
    async isA11yRadioMixContents(){
        const toggleActiveItem = this.$el[0].querySelector('.ui-ToggleRadio.input-radio-btn-area .toggle-item.active');
        const toggleItemEles = this.$el[0].querySelectorAll('.ui-ToggleRadio.input-radio-btn-area .toggle-item');
        const toggleInputEles = this.$el[0].querySelectorAll('.ui-ToggleRadio.input-radio-btn-area .toggle-item input');

        if(!toggleActiveItem) return;

        //다른 로직에서 tabindex 넣는 로직이 존재하여 해당 로직보다 뒤로 실행시키기위해 비동기로 실행
        const delay = new Promise((resolve) => setTimeout(resolve, 500));

        await delay;

        //toggleRadio 하위 input 스크린리더 focus막기
        await Array.from(toggleInputEles).forEach((list) => {
            list.setAttribute('aria-hidden','true');
            list.style.zIndex = '-1';
        });

        await Array.from(toggleItemEles).forEach((list,idx) => {
            const toggleDiv = list;
            const toggleItem = list.querySelector('a, label');
            const toggleSpan = list.querySelector('span');
            const toggleInputEle = list.querySelector('input');
            const isToggleInputDisabled = toggleInputEle.disabled;

            toggleDiv.setAttribute('role','radio');
            toggleDiv.setAttribute('aria-checked','false');
            // toggleDiv.setAttribute('title', `${toggleItem?.children[0]?.innerText}`);
            toggleDiv.setAttribute('aria-label', `${toggleItem?.children[0]?.innerText}`); //A11YTASK-469,477,483 : title속성 aria-label로 변경 (2025.04.09)
            
            toggleActiveItem?.setAttribute('aria-checked','true');

            toggleItem?.removeAttribute('tabindex');
            toggleItem?.setAttribute('aria-hidden','true');

            toggleSpan?.setAttribute('aria-hidden','true');

            toggleInputEle?.removeAttribute('tabindex');

            if(isToggleInputDisabled){
                //인풋 disabled 적용
                toggleDiv.removeAttribute('aria-checked');
                toggleDiv.setAttribute('disabled','true');
                // toggleDiv.setAttribute('title', '선택할수없음');
                toggleDiv.setAttribute('aria-label', '선택할수없음'); //A11YTASK-469,477,483 : title속성 aria-label로 변경 (2025.04.09)
                toggleDiv.style.pointerEvents = 'none';
            }

            toggleDiv.addEventListener('click',(e) => {
                if(isToggleInputDisabled) return;

                console.log('isA11yRadioMixContents click');
                
                Array.from([...toggleItemEles, ...toggleInputEles]).forEach((list) => {

                    if(list.nodeName === 'DIV'){
                        list.setAttribute('aria-checked','false');
                    }
                });

                // toggleDiv.setAttribute('title', `${toggleItem?.children[0]?.innerText}`);
                toggleDiv.setAttribute('aria-label', `${toggleItem?.children[0]?.innerText}`); //A11YTASK-469,477,483 : title속성 aria-label로 변경 (2025.04.09)
                
                toggleDiv.setAttribute('aria-checked','true');

                toggleInputEle.setAttribute('title', '');
                
                //$(toggleInputEles).prop('checked', false);
                //$(toggleInputEle).prop('checked', true);
                $(toggleInputEle).trigger('click');
            });
        });
    }
    /*! e: FETASK-a11y page 일반 isA11yRadioMixContents 로직 v.1.0.0 */
}

export default ToggleRadio;